module.exports = __webpack_public_path__ + "audio/tenAudio.aa4cba19.mp3";